import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DashboardCategorySummaryVM, DashboardQuestionSummaryVM, IdNameVM, SiteCodes } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { SafetyGeneraldashboardService } from '../services/safety-generaldashboard.service';

const dnutchart = {
  chart: {
    showBorder: "0",
    canvasBorderAlpha :"0",
   // caption: "Inspections Observations",
    //subcaption: "For all users in 2017",
    palettecolors: "#FF0000, #52AC5A, #FFA500",
   // showpercentvalues: "1",
   // defaultcenterlabel: "Android Distribution",
  //  aligncaptionwithcanvas: "0",
   // captionpadding: "0",
  //  decimals: "1",
    plottooltext:
      "<b>$label</b> <b>$value</b>",
    //centerlabel: "# Users: $value",
    theme: "fusion",
    borderThickness: "0",
    borderAlpha: "0",
    pieRadius: "100",
    doughnutRadius: "50",
    showLabels:"0",
    enableSmartLabels:"0",
    showValues:"0"
  },
  data: [
    {
      label: "Unsafe",
      value: "0"
    },
    {
      label: "Safe",
      value: "0"
    },
    {
      label: "Unanswered",
      value: "0"
    }
  ]
};


@Component({
  selector: 'app-safety-observation-dashboard',
  templateUrl: './safety-observation-dashboard.component.html',
  styleUrls: ['./safety-observation-dashboard.component.css']
})
export class SafetyObservationDashboardComponent implements OnInit {

  width = 419;
  height = 250;
  type = "doughnut2d";
  dataFormat = "json";
  dataSource = dnutchart;

  constructor(private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private _safetyConfigService:SafetyConfigService) { }

  ngOnInit() {
  //  this._appService.setPageTitle('');
    //this._appService.setPageSubTitle('');
    this.getMonthList();
    this.loadSiteList();
  
  }
  inputValueMonth:number;
  stateID:number=0
  inputValueSefetyObservation:number=4
  monthList: IdNameVM[] = [];
  siteCodesList: SiteCodes[]=[];

  //dashboard labels
  Inspections
  Observations
  CategorySummary: DashboardCategorySummaryVM[]=[]
  Questions:DashboardQuestionSummaryVM[]=[]
  QuestionName:string
  Safe:number
  Unsafe:number
  Unanswered:number
  total
  SafePct:number
  UnsafePct:number
  UnansweredPct:number
 // donutChart=[]

  chartdata:DashboardCategorySummaryVM[]=[]
  filteredChartData:DashboardQuestionSummaryVM[]=[]
   

  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }
  
  getMonthList() {
    this._safetyGeneraldashboardService.GetMonthsForDashboard().subscribe(res => {

      this.monthList = res
      this.inputValueMonth = 1;
      this.changeValue(0);
      
    });

  }
  loadSiteList()
  {
    this._safetyConfigService.getAllSitesList().subscribe(sites =>
    { 
      console.log('sitelist',sites)
      this.siteCodesList=sites;
      
    });
  }
  reloadfields()
  {
    this.changeValue(this.inputValueMonth);
  }
  
  changeobservationtype(value: any) {
    this.changeValue(this.inputValueMonth);  
  }

  changeValue(value: any) {
    let Id: any;  
    
    Id = this.monthList.filter(item => item.Id == value)[0].Id
    console.log(Id)
    this.inputValueMonth = Id;
   
    console.log('before state ID' , this.stateID)
    console.log('month  ID' , Id)
    this._safetyGeneraldashboardService.GetSafetyChecklistDashboard(Id,this.stateID,this.inputValueSefetyObservation).subscribe(res=>{
      console.log(res)
      this.Inspections=res.DashboardSummary.TotalInspections
      this.Observations=res.DashboardSummary.TotalObservations
      this.CategorySummary=res.CategorySummary

  
  dnutchart.data[0].value=res.DashboardSummary.Failed.toString();
  dnutchart.data[1].value=res.DashboardSummary.Passed.toString();
  dnutchart.data[2].value=res.DashboardSummary.Incomplete.toString();
   


      this.CategorySummary.map(x=>{
        this.Questions=x.Questions
        this.total=this.Questions.length;
        this.Safe= this.CategorySummary.reduce((count, current) => count + current.Questions.filter(x=> x.Safe !=null && x.Safe==1).length, 0);
        this.Unsafe= this.CategorySummary.reduce((count, current) => count + current.Questions.filter(x=> x.Unsafe !=null && x.Unsafe==1).length, 0);
        this.Unanswered= this.CategorySummary.reduce((count, current) => count + current.Questions.filter(x=> x.Unanswered !=null && x.Unanswered==1).length, 0);
        this.SafePct= (this.Safe *100)/ this.total
        this.UnsafePct=(this.Unsafe *100)/ this.total
        this.UnansweredPct=(this.Unanswered *100)/ this.total

//         this.Questions.map(x=>{
//           this.QuestionName=x.QuestionName;
//           this.Safe=x.Safe
//           this.Unanswered=x.Unanswered
//           this.Unsafe=x.Unsafe
//           this.total= this.Safe + this.Unanswered + this.Unsafe;
//           this.SafePct= (this.Safe *100)/ this.total
//           this.UnsafePct=(this.Unsafe *100)/ this.total
//           this.UnansweredPct=(this.Unanswered *100)/ this.total
console.log("Safe summary", this.SafePct )
console.log("Unsafe summary", this.UnsafePct )
console.log("Ununswered summary", this.UnansweredPct )
console.log("total", this.total )
//           })

          
      })
      

    })
    
  }
  refreshChart()
  {
    dnutchart.data=[]
  }

}
